export default __webpack_public_path__ + "images/careCoordination.392091aff58381d7036e20a0e68013b7.svg";